var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'antd/lib/collapse';
import 'codemirror/mode/css/css.js';
import 'codemirror/addon/hint/show-hint.js';
import 'codemirror/addon/hint/css-hint.js';
import CodeMirror from './common/CodeMirror';
var Panel = Collapse.Panel;
var EditorCss = /** @class */ (function (_super) {
    __extends(EditorCss, _super);
    function EditorCss() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (value) {
            _this.props.onChange(value.replace(/{\n|\n}|{|}/g, ''));
        };
        _this.onKeyUp = function (cm, event) {
            if (!cm.state.completionActive &&
                (event.key.match(/[a-z]/ig) &&
                    event.key.length === 1 ||
                    event.keyCode === 32)) {
                cm.showHint();
            }
        };
        return _this;
    }
    EditorCss.prototype.render = function () {
        var _this = this;
        var props = __rest(this.props, []);
        var value = props.value, locale = props.locale;
        ['defaultData', 'onChange'].map(function (key) { return delete props[key]; });
        var newValue = "{\n" + value + "\n}";
        return (React.createElement(Panel, __assign({}, props, { header: props.header || locale.header }),
            React.createElement(CodeMirror, { value: newValue, options: {
                    mode: { name: 'css', globalVars: true },
                    theme: 'ambiance',
                }, onKeyUp: this.onKeyUp, onBlur: function (_, __, v) {
                    if (v.replace(/\s+/g, '') !== newValue.replace(/\s+/g, '')) {
                        _this.onChange(v);
                    }
                } })));
    };
    EditorCss.propTypes = {
        value: PropTypes.string,
        onChange: PropTypes.func,
        cssName: PropTypes.string,
        header: PropTypes.string,
    };
    EditorCss.defaultProps = {
        value: '',
        onChange: function () {
        },
    };
    return EditorCss;
}(Component));
export default EditorCss;
EditorCss.componentName = 'EditorCss';
